module.exports = __webpack_public_path__ + "media/1-5cc8d829.jpg";